module.exports = __webpack_public_path__ + "static/media/emergency-medicine-banner.3e4674c4.png";